// Zweisprachiger Inhalt für die Lebenslauf-Seite (unabhängig von der
// globalen Seiten-Sprache – eigener Umschalter direkt auf der Seite).

const lebenslaufContent = {
  de: {
    ui: {
      back: '← Zurück zur Übersicht',
      langLabel: 'CV-Sprache',
      showPhoto: 'Foto anzeigen',
      hidePhoto: 'Foto ausblenden',
      editStart: 'Elemente ein-/ausblenden',
      editDone: 'Fertig',
      showAll: 'Alle einblenden',
      hideElement: 'Ausblenden',
      showElement: 'Einblenden',
      downloadPdf: 'PDF herunterladen',
      downloadingPdf: 'Erstelle PDF...',
      downloadImage: 'Bild herunterladen',
      downloadingImage: 'Erstelle Bild...',
      errorPdf: 'Fehler beim Erstellen der PDF',
      errorImage: 'Fehler beim Erstellen des Bildes',
      addressBerlin: 'Berlin',
      addressNuremberg: 'Nürnberg',
    },
    name: 'Emin Tavli',
    title: 'Fullstack Developer',
    summary:
      'Fullstack-Entwickler und IT-Administrator mit über vier Jahren Erfahrung in TYPO3, Linux/Plesk-Servern, Docker und Azure DevOps.',
    sections: {
      contact: 'Kontakt',
      skills: 'Technische Skills',
      tech: 'Tools & Technologien',
      languages: 'Sprachen',
      experience: 'Beruflicher Werdegang',
      education: 'Akademischer Werdegang',
      additional: 'Weitere Informationen',
      schoolEducation: 'Schulische Ausbildung',
      earlyExperience: 'Frühe Berufserfahrungen',
    },
    tech: 'Docker, Linux, Kubernetes, DDEV, GitLab, TYPO3 (Extbase/Fluid), Plesk, Active Directory, Azure DevOps',
    birthDate: 'Geburtsdatum: 26.07.1992',
    present: 'heute',
    languages: [
      { name: 'Deutsch', level: 'C2' },
      { name: 'Englisch', level: 'C2' },
      { name: 'Türkisch', level: 'C2' },
      { name: 'Spanisch', level: 'B1' },
    ],
    experience: [
      {
        role: 'Fullstack-Entwickler',
        company: 'MBS Nürnberg',
        duration: '05/2021 - 03/2026',
        bullets: [
          'Entwicklung und Wartung von unternehmenskritischen Webanwendungen',
          'Implementierung von RESTful APIs und Microservices',
          'Optimierung der Entwicklungsprozesse und CI/CD-Pipeline',
          'Technische Führung in Projektteams',
          'Entwicklung mit TYPO3, WordPress, React, Laravel und Vue.js',
          'Einrichtung und Konfiguration neuer Arbeitsplätze inkl. Betriebssystem- und Softwareinstallation',
          'IT-Administrator: Verwaltung von Benutzerkonten, Berechtigungen und Gruppenrichtlinien im Active Directory',
          'Pflege und Administration der internen IT-Infrastruktur',
          'Administration der Plesk-Server sowie Hosting-Verwaltung aller Unternehmenswebsites und -projekte',
          'Sicherstellung von Aktualität und Sicherheit der gehosteten Projekte durch regelmäßige Updates, Wartung und Backups',
          'Installation und Bereitstellung interner Anwendungen im Firmennetzwerk, u. a. Ticketsystem für Mitarbeiter-Supportanfragen und Arbeitszeittracker',
        ],
      },
      {
        role: 'Selbstständiger Webentwickler',
        company: 'Eigenes Gewerbe',
        duration: '01/2020 - heute',
        bullets: [
          'Entwicklung von maßgeschneiderten Webseiten und Online-Shops für Kunden',
          'Spezialisierung auf WooCommerce und WordPress-basierte Lösungen',
          'Beratung und Implementierung von E-Commerce-Strategien',
          'Wartung und Optimierung bestehender Webprojekte',
        ],
      },
      {
        role: 'Werkstudent Webentwicklung',
        company: 'Arzte.de',
        duration: '01/2019 - 10/2020',
        bullets: [
          'Frontend-Entwicklung mit React.js',
          'Implementierung responsiver Designs',
          'Optimierung der Website-Performance',
          'Zusammenarbeit in agilen Entwicklungsteam',
        ],
      },
      {
        role: 'Praktikum & Werkstudent',
        company: 'IT-Labs',
        duration: '08/2018 - 12/2018',
        bullets: [
          'Erste praktische Erfahrungen in der Webentwicklung und Kennenlernen verschiedener Technologien',
        ],
      },
      {
        role: 'PC-Zusammenbau & Verkauf',
        company: 'K&K Computer',
        duration: '02/2017 - 08/2017',
        bullets: [
          'Zusammenbau von PCs nach Kundenanforderungen',
          'Kundenberatung zu Hardware und PC-Konfigurationen',
          'Verkauf von PC-Teilen und Zubehör',
        ],
      },
    ],
    education: [
      {
        degree: 'Weiterbildung: Azure, DevOps & Security (abgeschlossen)',
        institution: 'Zertifizierungen: AZ-900, AZ-204, AI-900, AZ-400, Security+',
        duration: '03/2026 - 08/2026',
        bullets: [
          'Microsoft Azure Fundamentals (AZ-900) – bestanden',
          'Azure Developer Associate (AZ-204) – bestanden',
          'Azure AI Fundamentals (AI-900) – bestanden',
          'Azure DevOps Engineer Expert (AZ-400) – bestanden',
          'CompTIA Security+ – bestanden',
        ],
      },
      {
        degree: 'Media Engineering (Bachelor of Engineering)',
        institution: 'TH-Nürnberg',
        duration: '10/2014 - 01/2020',
        bullets: [
          'Schwerpunkt: Webentwicklung und Medientechnologie',
          'Bachelorarbeit: "Entwicklung einer skalierbaren Webanwendung mit React.js"',
          'Aktive Teilnahme an Hochschulprojekten',
        ],
      },
      {
        degree: 'Fachoberschule',
        institution: 'Lothar von Faber, Nürnberg',
        duration: '2011 - 2014',
        bullets: ['Abschluss mit Fachhochschulreife, Schwerpunkt Technik'],
      },
    ],
    additional: {
      schoolEducation: [
        '2007 - 2011 Adam-Kraft-Realschule',
        '2005 - 2007 Realschule Lehrte',
        '1999 - 2005 Löwenzahn Grundschule in Berlin',
      ],
      earlyExperience: [
        '2012 Praktikum Prüfungsstelle Arzte Bayern',
        '2011 - 2012 Praktikum Amtsgericht Nürnberg',
        '2009 Kaufmännisches Praktikum',
      ],
    },
  },

  en: {
    ui: {
      back: '← Back to Overview',
      langLabel: 'CV language',
      showPhoto: 'Show photo',
      hidePhoto: 'Hide photo',
      editStart: 'Show/hide elements',
      editDone: 'Done',
      showAll: 'Show all',
      hideElement: 'Hide',
      showElement: 'Show',
      downloadPdf: 'Download PDF',
      downloadingPdf: 'Creating PDF...',
      downloadImage: 'Download Image',
      downloadingImage: 'Creating image...',
      errorPdf: 'Error creating PDF',
      errorImage: 'Error creating image',
      addressBerlin: 'Berlin',
      addressNuremberg: 'Nuremberg',
    },
    name: 'Emin Tavli',
    title: 'Fullstack Developer',
    summary:
      'Fullstack developer and IT administrator with over four years of experience in TYPO3, Linux/Plesk servers, Docker and Azure DevOps.',
    sections: {
      contact: 'Contact',
      skills: 'Technical Skills',
      tech: 'Tools & Technologies',
      languages: 'Languages',
      experience: 'Professional Experience',
      education: 'Academic Background',
      additional: 'Additional Information',
      schoolEducation: 'School Education',
      earlyExperience: 'Early Work Experience',
    },
    tech: 'Docker, Linux, Kubernetes, DDEV, GitLab, TYPO3 (Extbase/Fluid), Plesk, Active Directory, Azure DevOps',
    birthDate: 'Date of birth: 26.07.1992',
    present: 'present',
    languages: [
      { name: 'German', level: 'C2' },
      { name: 'English', level: 'C2' },
      { name: 'Turkish', level: 'C2' },
      { name: 'Spanish', level: 'B1' },
    ],
    experience: [
      {
        role: 'Fullstack Developer',
        company: 'MBS Nürnberg',
        duration: '05/2021 - 03/2026',
        bullets: [
          'Development and maintenance of business-critical web applications',
          'Implementation of RESTful APIs and microservices',
          'Optimization of development processes and the CI/CD pipeline',
          'Technical leadership within project teams',
          'Development with TYPO3, WordPress, React, Laravel and Vue.js',
          'Setup and configuration of new workstations, incl. OS and software installation',
          'IT administrator: managed user accounts, permissions and group policies in Active Directory',
          'Maintenance and administration of internal IT infrastructure',
          'Administration of Plesk servers and hosting management for all company websites and projects',
          'Kept hosted projects current and secure through regular updates, maintenance and backups',
          'Installation and deployment of internal applications on the company network, incl. a support ticketing system and a time-tracking tool',
        ],
      },
      {
        role: 'Freelance Web Developer',
        company: 'Self-employed',
        duration: '01/2020 - present',
        bullets: [
          'Development of custom websites and online shops for clients',
          'Specialization in WooCommerce and WordPress-based solutions',
          'Consulting on and implementation of e-commerce strategies',
          'Maintenance and optimization of existing web projects',
        ],
      },
      {
        role: 'Working Student, Web Development',
        company: 'Arzte.de',
        duration: '01/2019 - 10/2020',
        bullets: [
          'Frontend development with React.js',
          'Implementation of responsive designs',
          'Website performance optimization',
          'Collaboration within an agile development team',
        ],
      },
      {
        role: 'Internship & Working Student',
        company: 'IT-Labs',
        duration: '08/2018 - 12/2018',
        bullets: [
          'First hands-on experience in web development and exposure to various technologies',
        ],
      },
      {
        role: 'PC Assembly & Sales',
        company: 'K&K Computer',
        duration: '02/2017 - 08/2017',
        bullets: [
          'Assembling PCs to customer specifications',
          'Customer consulting on hardware and PC configurations',
          'Sales of PC components and accessories',
        ],
      },
    ],
    education: [
      {
        degree: 'Further Training: Azure, DevOps & Security (completed)',
        institution: 'Certifications: AZ-900, AZ-204, AI-900, AZ-400, Security+',
        duration: '03/2026 - 08/2026',
        bullets: [
          'Microsoft Azure Fundamentals (AZ-900) – passed',
          'Azure Developer Associate (AZ-204) – passed',
          'Azure AI Fundamentals (AI-900) – passed',
          'Azure DevOps Engineer Expert (AZ-400) – passed',
          'CompTIA Security+ – passed',
        ],
      },
      {
        degree: 'Media Engineering (Bachelor of Engineering)',
        institution: 'TH Nürnberg',
        duration: '10/2014 - 01/2020',
        bullets: [
          'Focus: web development and media technology',
          'Bachelor’s thesis: "Development of a Scalable Web Application with React.js"',
          'Active participation in university projects',
        ],
      },
      {
        degree: 'Fachoberschule (Technical Secondary School)',
        institution: 'Lothar von Faber, Nürnberg',
        duration: '2011 - 2014',
        bullets: [
          'Graduated with Fachhochschulreife (technical college entrance qualification), focus on technology',
        ],
      },
    ],
    additional: {
      schoolEducation: [
        '2007 - 2011 Adam-Kraft-Realschule',
        '2005 - 2007 Realschule Lehrte',
        '1999 - 2005 Löwenzahn Grundschule, Berlin',
      ],
      earlyExperience: [
        '2012 Internship, Physicians’ Examination Board Bavaria',
        '2011 - 2012 Internship, Nuremberg Local Court',
        '2009 Business/administrative internship',
      ],
    },
  },
};

export default lebenslaufContent;
